import {Descriptor, Region, Regions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {applyAddressModeToRegion} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-utils"
import {BorderMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/convolve-helper-hal"

export const applyBorderModeToRegion = (descriptor: Descriptor, region: Region, mipLevel: number, borderMode: BorderMode): Regions => {
    if (borderMode === "renormalize") {
        return [region]
    } else {
        return applyAddressModeToRegion(descriptor, region, mipLevel, borderMode)
    }
}
